import { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQ = () => {
  const faqSections = [
    {
      title: "Allgemeine Fragen",
      questions: [
        {
          q: "Wer kann Teil des Angel & Devil Networks werden?",
          a: "Jeder, der in der Webcam-Branche tätig werden möchte oder bereits aktiv ist. Egal, ob du Anfänger oder Profi bist – wir unterstützen Performer jeden Levels."
        },
        {
          q: "Was kostet es, mit euch zu arbeiten?",
          a: "Die Registrierung und Nutzung unseres Netzwerks sind kostenlos. Du bekommst ein Starterpaket und kannst unsere Services nutzen – wir verdienen erst mit, wenn du erfolgreich bist."
        },
        {
          q: "Muss ich mich an bestimmte Plattformen binden?",
          a: "Nein. Wir arbeiten mit Plattformen wie Strip-Chat, myDirtyHobby und vielen anderen zusammen. Du kannst entscheiden, wo du aktiv sein möchtest."
        }
      ]
    },
    {
      title: "Leistungen & Ausstattung",
      questions: [
        {
          q: "Was ist im Starterpaket enthalten?",
          a: "Unser Starterpaket beinhaltet:\n\n• Einen hochwertigen Laptop\n• Eine professionelle Kamera\n• Lichttechnik\n• Ein Lovense-Toy für interaktive Streams"
        },
        {
          q: "Kann ich eure Studio-Wohnungen nutzen?",
          a: "Ja! Nach einer Zusammenarbeit von mindestens sechs Monaten kannst du auf unser Studio-Wohnnetzwerk zugreifen. Die Apartments sind voll ausgestattet und perfekt für Multi-Streaming geeignet."
        },
        {
          q: "Was passiert, wenn ich mein Equipment beschädige?",
          a: "Kein Problem! Unser Team unterstützt dich bei Reparaturen oder einem Austausch. Kontaktiere uns einfach, und wir kümmern uns um eine Lösung."
        }
      ]
    },
    {
      title: "Netzwerk & Betreuung",
      questions: [
        {
          q: "Wie unterstützt ihr mich bei meiner Arbeit?",
          a: "Wir bieten dir:\n\n• Technische Beratung für dein Equipment\n• Tipps zur Content-Produktion\n• Plattform-Beratung, damit du auf den richtigen Kanälen erfolgreich bist\n• Zugang zu exklusiven Preisen für Toys, Dessous und mehr"
        },
        {
          q: "Kann ich Hilfe bei Outfits und Styling bekommen?",
          a: "Ja! Nach einer Probezeit von drei Wochen stellen wir dir drei komplette Outfits zur Verfügung, damit du perfekt starten kannst."
        }
      ]
    },
    {
      title: "Rechtliches & Datenschutz",
      questions: [
        {
          q: "Wie schützt ihr meine Privatsphäre?",
          a: "Deine Daten und Privatsphäre sind bei uns sicher. Wir arbeiten mit den höchsten Datenschutzstandards und geben deine Informationen niemals ohne Zustimmung weiter."
        },
        {
          q: "Muss ich ein Gewerbe anmelden?",
          a: "Ja, in Deutschland benötigst du als Webcam-Performer ein angemeldetes Gewerbe. Wir helfen dir gerne dabei, die ersten Schritte zu gehen."
        }
      ]
    }
  ];

  const [openQuestions, setOpenQuestions] = useState({});

  const toggleQuestion = (sectionIndex, questionIndex) => {
    const key = `${sectionIndex}-${questionIndex}`;
    setOpenQuestions(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  return (
    <div className="pt-20 w-full">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden w-full">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              FAQ – <span className="text-gradient">Häufig gestellte Fragen</span>
            </h1>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-8">
              Where <span className="text-hot-pink">Temptation</span> Meets <span className="text-accent-purple">Talent</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80 mb-8">
              Wir wissen, dass du viele Fragen haben könntest, bevor du dich unserem Netzwerk anschließt. 
              Hier findest du die wichtigsten Antworten. Wenn du weitere Fragen hast, kontaktiere uns einfach direkt!
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Sections */}
      <section className="py-20 w-full">
        <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 max-w-none">
            {faqSections.map((section, sectionIndex) => (
              <div key={sectionIndex} className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8">
                  <h2 className="text-2xl sm:text-3xl font-playfair text-gradient mb-6">{section.title}</h2>
                  <div className="space-y-4">
                    {section.questions.map((item, questionIndex) => {
                      const key = `${sectionIndex}-${questionIndex}`;
                      return (
                        <div key={questionIndex} className="relative">
                          <button
                            className="w-full text-left p-4 rounded-xl bg-deep-black/50 hover:bg-deep-black/70 transition-colors duration-300"
                            onClick={() => toggleQuestion(sectionIndex, questionIndex)}
                          >
                            <div className="flex justify-between items-center">
                              <h3 className="text-lg font-medium pr-8">{item.q}</h3>
                              <span className={`transform transition-transform duration-300 ${openQuestions[key] ? 'rotate-180' : ''}`}>
                                ▼
                              </span>
                            </div>
                          </button>
                          <div className={`overflow-hidden transition-all duration-300 ${openQuestions[key] ? 'max-h-96 mt-4' : 'max-h-0'}`}>
                            <div className="p-4 rounded-xl bg-deep-black/30">
                              <p className="text-white/80 whitespace-pre-line">{item.a}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 w-full">
        <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative max-w-4xl mx-auto text-center">
            <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
            <div className="relative glass-effect rounded-2xl p-12">
              <h2 className="text-2xl sm:text-3xl font-playfair mb-6">
                Hast du weitere Fragen?
              </h2>
              <p className="text-xl text-white/90 mb-8">
                Kontaktiere uns jederzeit! Unser Team steht dir unter{' '}
                <a href="mailto:info@angel-devil.network" className="text-hot-pink hover:text-accent-purple transition-colors">
                  info@angel-devil.network
                </a>{' '}
                zur Verfügung.
              </p>
              <div className="text-center mt-12 space-x-4">
                <Link
                  to="/kontakt"
                  className="bg-pink-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-pink-700 transition duration-300 inline-block"
                >
                  Kontakt aufnehmen
                </Link>
                <Link
                  to="/bewerbung"
                  className="bg-pink-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-pink-700 transition duration-300 inline-block"
                >
                  Jetzt bewerben
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
